import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';

// --- Globale Komponenten ---
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// --- Öffentliche Seiten ---
import Home from './pages/Home';
import Unternehmen from './pages/Unternehmen';
import Karriere from './pages/Karriere';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import ApplicationSuccess from './pages/public/ApplicationSuccess';

// --- Admin Seiten & Layout ---
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './components/admin/AdminLayout';
import ProtectedRoute from './components/admin/ProtectedRoute';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminApplications from './pages/admin/AdminApplications';
import AdminTestSessions from './pages/admin/AdminTestSessions';
import AdminTasks from './pages/admin/AdminTasks';
import AdminDokumente from './pages/admin/AdminDokumente';
import AdminVerifications from './pages/admin/AdminVerifications';
import AdminReferrals from './pages/admin/AdminReferrals';
import AdminAnosim from './pages/admin/AdminAnosim';
import AdminReports from './pages/admin/AdminReports';

// --- Mitarbeiter Seiten & Layout ---
import MitarbeiterLogin from './pages/mitarbeiter/MitarbeiterLogin';
import MitarbeiterLayout from './components/mitarbeiter/MitarbeiterLayout';
import ProtectedEmployeeRoute from './components/mitarbeiter/ProtectedEmployeeRoute';
import MitarbeiterDashboard from './pages/mitarbeiter/MitarbeiterDashboard';
import MitarbeiterAuftrage from './pages/mitarbeiter/MitarbeiterAuftrage';
import MitarbeiterVerification from './pages/mitarbeiter/MitarbeiterVerification';
import MitarbeiterQuiz from './pages/mitarbeiter/MitarbeiterQuiz';
import MitarbeiterEinstellungen from './pages/mitarbeiter/MitarbeiterEinstellungen';
import MitarbeiterPending from './pages/mitarbeiter/MitarbeiterPending';

// Ein Wrapper-Layout NUR für die öffentlichen Seiten (mit Navbar und Footer)
const PublicLayout = () => (
  <div className="flex flex-col min-h-screen font-sans bg-background">
    <Navbar />
    <main className="flex-grow">
      <Outlet />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <Router>
      <Routes>
        
        {/* =========================================
            ÖFFENTLICHE ROUTEN (mit Navbar & Footer)
        ============================================= */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/ueber-uns" element={<Unternehmen />} />
          <Route path="/karriere" element={<Karriere />} />
          <Route path="/kontakt" element={<Impressum />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/success" element={<ApplicationSuccess />} />
        </Route>

        {/* =========================================
            ADMIN ROUTEN (eigenes Layout & Sidebar)
        ============================================= */}
        <Route path="/admin/login" element={<AdminLogin />} />
        
        {/* Geschützter Admin-Bereich */}
        <Route path="/admin" element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="applications" element={<AdminApplications />} />
            <Route path="test-sessions" element={<AdminTestSessions />} />
            <Route path="tasks" element={<AdminTasks />} />
            <Route path="dokumente" element={<AdminDokumente />} />
            <Route path="verifications" element={<AdminVerifications />} />
            <Route path="referrals" element={<AdminReferrals />} />
            <Route path="anosim" element={<AdminAnosim />} />
            <Route path="reports" element={<AdminReports />} />
          </Route>
        </Route>

        {/* =========================================
            MITARBEITER ROUTEN (eigenes Layout & Sidebar)
        ============================================= */}
        <Route path="/mitarbeiter/login" element={<MitarbeiterLogin />} />
        
        {/* Geschützter Tester-Bereich */}
        <Route path="/mitarbeiter" element={<ProtectedEmployeeRoute />}>
          <Route element={<MitarbeiterLayout />}>
            <Route path="dashboard" element={<MitarbeiterDashboard />} />
            <Route path="auftrage" element={<MitarbeiterAuftrage />} />
            <Route path="verification" element={<MitarbeiterVerification />} />
            <Route path="quiz" element={<MitarbeiterQuiz />} />
            <Route path="einstellungen" element={<MitarbeiterEinstellungen />} />
            <Route path="pending" element={<MitarbeiterPending />} />
          </Route>
        </Route>

      </Routes>
    </Router>
  );
}

export default App;